// components
import emailVerification from "./components/email-verification.json";
import PaidResponse from "./components/PaidResponse.json";
import passwordWindows from "./components/passwordWindows.json";
import reuseComponent from "./components/reuseComponent.json";
import signupComponent from "./components/signupComponent.json";

// dashboard 
import registrarDashboard from "./dashboard/registrarDashboard.json";
import userDashboard from "./dashboard/userDashboard.json";


import about from "./about.json";
import AgentDetails from "./agent_details_questions.json";
import changePassword from "./changePassword.json";
import consultant from "./consultant.json";
import faq from "./faq.json";
import forgotpassword from "./forgotpassword.json";
import footer from "./footer.json";
import header from "./header.json";
import hireConsultant from "./hireConsultant.json";
import login from "./login.json";
import profile from "./profile.json";
import registrar_info from "./registrar_info.json";
import signup_intro from "./signup_intro.json";
import signup from "./signup.json";
import termsAndService from "./termsAndService.json";
import commonTranslation from "./common.json";

import successMessages from "./serverMessages/successMessages";
import failureMessages from "./serverMessages/failureMessages";

const en = {
    translation: {
        ...commonTranslation,
        ...emailVerification,
        ...PaidResponse,
        ...passwordWindows,
        ...reuseComponent,
        ...signupComponent,

        ...registrarDashboard,
        ...userDashboard,

        ...changePassword,
        ...faq,
        ...forgotpassword,
        ...login,
        ...profile,
        ...signup,
        ...termsAndService,
        ...consultant,
        ...footer,
        ...header,
        ...hireConsultant,
        ...about,
        ...registrar_info,
        ...signup_intro,
        ...AgentDetails,
        ...failureMessages,
        ...successMessages
    }
}
export default en